import React from 'react'
import PropTypes from 'prop-types'

const IconX = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" width="12">
    <path d="M11.94 9.46L20.86.6a1.8 1.8 0 0 1 3.09.77c.16.64-.05 1.32-.54 1.76L14.49 12l8.92 8.88a1.79 1.79 0 0 1-.77 3.07 1.8 1.8 0 0 1-1.78-.54l-8.92-8.87-8.92 8.87c-.71.65-1.81.62-2.5-.05a1.79 1.79 0 0 1-.05-2.48L9.39 12 .47 3.12c-.65-.7-.62-1.8.06-2.48C1.2-.03 2.3-.06 3.02.6l8.92 8.87z" />
  </svg>
)

IconX.propTypes = {
  className: PropTypes.string,
}

IconX.defaultProps = {
  className: '',
}

export default IconX
